(() => {
  if (customElements.get('zyvoria-ugc-rail')) return;

  class ZyvoraUgcRail extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-ugc-viewport]');
      this.track = this.querySelector('[data-ugc-track]');
      this.group = this.querySelector('[data-ugc-group]');
      this.progress = this.querySelector('[data-ugc-progress]');
      this.isPaused = false;
      this.isVisible = true;
      this.lastTime = 0;
      this.scrollPosition = 0;

      if (!this.viewport || !this.track || !this.group) return;

      this.updateProgress = () => {
        if (!this.progress || !this.group.scrollWidth) return;
        const progress = (this.viewport.scrollLeft % this.group.scrollWidth) / this.group.scrollWidth;
        this.progress.style.transform = `translateX(${progress * 300}%)`;
        if (this.isPaused) this.scrollPosition = this.viewport.scrollLeft;
      };

      this.viewport.addEventListener('scroll', this.updateProgress, { passive: true });

      if (
        this.hasAttribute('data-design-mode') ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        return;
      }

      const clone = this.group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-ugc-group');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((element) => {
        element.removeAttribute('data-shopify-editor-block');
      });
      this.track.appendChild(clone);
      this.scrollPosition = this.viewport.scrollLeft;

      this.addEventListener('mouseenter', () => {
        this.isPaused = true;
      });
      this.addEventListener('mouseleave', () => {
        this.isPaused = false;
      });
      this.addEventListener('focusin', () => {
        this.isPaused = true;
      });
      this.addEventListener('focusout', () => {
        this.isPaused = false;
      });
      this.viewport.addEventListener('pointerdown', () => {
        this.isPaused = true;
      });
      this.onPointerUp = () => {
        this.isPaused = false;
      };
      window.addEventListener('pointerup', this.onPointerUp);

      this.observer = new IntersectionObserver(([entry]) => {
        this.isVisible = entry.isIntersecting;
      });
      this.observer.observe(this);

      this.tick = (time) => {
        const elapsed = this.lastTime ? Math.min(time - this.lastTime, 40) : 0;
        this.lastTime = time;

        if (!this.isPaused && this.isVisible && this.group.scrollWidth) {
          const speed = Number(this.dataset.speed || 3) * 0.012;
          this.scrollPosition += elapsed * speed;
          if (this.scrollPosition >= this.group.scrollWidth) {
            this.scrollPosition -= this.group.scrollWidth;
          }
          this.viewport.scrollLeft = this.scrollPosition;
          this.updateProgress();
        }

        this.frame = requestAnimationFrame(this.tick);
      };

      this.frame = requestAnimationFrame(this.tick);
    }

    disconnectedCallback() {
      if (this.frame) cancelAnimationFrame(this.frame);
      if (this.observer) this.observer.disconnect();
      if (this.onPointerUp) window.removeEventListener('pointerup', this.onPointerUp);
    }
  }

  customElements.define('zyvoria-ugc-rail', ZyvoraUgcRail);
})();
